import { store } from '@/common/root';

const fetchDomainName = async (domainId: ID): Promise<string> => {
  const domain = await store.$takeFirst('domains/domains/GET_OR_LOAD', { id: domainId });
  return domain.name;
};

export default fetchDomainName;
